
export class OrderShipmentActionParamsDTO {
    action: any;
    loadedWeightInTons: number;
    
    constructor(action: any, loadedWeightInTons?: number) {
        this.action = action;
        this.loadedWeightInTons = loadedWeightInTons || 0;
    }
}

export enum OrderShipmentAction {
    DO_PARKING,
    PREPARE_TO_LOAD,
    START_LOADING,
    START_LOAD_CHECK,
    COMPLETE_LOAD_CHECK,
    START_LOAD_WEIGHT_CHECK,
    COMPLETE_LOAD_WEIGHT_CHECK,
    START_DELIVERY, 
    SET_AS_DELIVERY_COMPLETED,
    SET_AS_RETURNING_TO_WAREHOUSE,
    TRANSFER_TO_ANOTHER,
}
